import { render, staticRenderFns } from "./EditCustomerGroupProperty.vue?vue&type=template&id=1392407c"
import script from "./EditCustomerGroupProperty.vue?vue&type=script&lang=ts"
export * from "./EditCustomerGroupProperty.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports